<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات پیام"
        >
          <b-form @submit.prevent>
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>
                  <b-col class="col-md-4">
                    <b-form-group
                        label="نوع"
                        label-for="notificationVia"
                        class="d-inline-block full-width"
                    >
                      <v-select
                          id="notificationVia"
                          v-model="form.Type"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="notificationGroup"
                          :clearable="false"
                          :options="enums('sendVia').filter(option => option.value !== null)"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col class="col-md-4">
                    <b-form-group
                      label="زمان ارسال"
                      label-for="SendTime"
                    >
                      <date-picker
                        v-model="form.SendTime"
                        placeholder=""
                        type="datetime"
                        format="YYYY-MM-DD HH:mm"
                        display-format="jYYYY-jMM-jDD HH:mm"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="تخفیف"
                        label-for="CouponId"
                    >
                      <z-coupon
                          v-model="form.CouponId"
                          :clearable="true"
                          :multiple="false"
                          :isDynamic="true"
                      />
                    </b-form-group>
                  </b-col>

                <b-col md="12">
                  <b-form-group
                      label="شناسه کاربر"
                      label-for="UserIds"
                  >
                    <b-form-tags
                        v-model="form.UserIds"
                        name="UserIds"
                        input-id="UserIds"
                        input-type="number"
                        duplicate-tag-text="این شناسه تکراری است"
                        placeholder=""
                        :number="true"
                        add-button-text="اضافه"
                        add-button-variant="outline-primary"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                      label="سگمنت"
                      label-for="SegmentIds"
                  >
                    <selectSegmentCustom
                        v-model="form.SegmentIds"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                      label="عنوان"
                      label-for="Title"
                  >
                    <b-form-input
                        id="Title"
                        v-model="form.Title"
                        autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                      label="لینک"
                      label-for="Uri"
                  >
                    <b-form-input
                        id="Uri"
                        v-model="form.Uri"
                        autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                      label="متن"
                      label-for="Description"
                  >
                    <b-form-textarea
                        id="Description"
                        v-model="form.Description"
                        name="Description"
                        rows="3"
                    />
                  </b-form-group>
                </b-col>


                <!--                <div class="d-flex flex-row">-->
                <!--                  <UploadFile-->
                <!--                    key="1"-->
                <!--                    v-model="form.image"-->
                <!--                    label="عکس نوتیف"-->
                <!--                    box-width="200px"-->
                <!--                    box-height="200px"-->
                <!--                  />-->
                <!--                  <UploadFile-->
                <!--                    key="2"-->
                <!--                    v-model="form.icon"-->
                <!--                    label="ایکون نوتیف"-->
                <!--                    box-width="200px"-->
                <!--                    box-height="200px"-->
                <!--                  />-->
                <!--                </div>-->
                <b-row v-if="form.Type === 1">
                  <b-col md="auto">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :disabled="form.Description.length === 0"
                      variant="outline-info"
                      size="sm"
                      pill
                      @click="calculatePrice"
                    >
                      <b-spinner
                        v-show="calculate.loading"
                        small
                        class="btn-loading"
                      />
                      <span>محاسبه</span>
                    </b-button>
                  </b-col>
                  <template v-if="calculate.isDone">
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy">  صفحه </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.PageCount }}
                      </b-badge>
                    </b-col>
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy"> تعداد  </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.SmsCount }}
                      </b-badge>
                    </b-col>
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy"> هزینه </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.FinalCost }}

                      </b-badge>
                    </b-col>
                  </template>

                </b-row>




                <b-col cols="12">
                  <b-form-group class="mt-1">
                    <b-form-checkbox
                        v-model="form.SaveInInbox"
                        value="true"
                        class="custom-control-success"
                    >
                      در صندوق پیام کاربر ذخیره شود.
                    </b-form-checkbox>

                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group class="mt-1 mb-2">
                    <b-form-checkbox
                        v-model="form.IsDraft"
                        value="true"
                        class="custom-control-info"
                    >
                      به عنوان پیش نویس ذخیره شود.
                    </b-form-checkbox>

                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>

                <b-col class="mt-1 mb-2 text-center">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                  >
                    ذخیره
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>

                </b-row>


              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import UploadFile from '@/tools/uploadFile.vue'
import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'
import ZCoupon from '@/tools/coupon.vue'

export default {
  name: 'SendNotification',
  components: { UploadFile, selectSegmentCustom, ZCoupon },
  data() {
    return {
      loading: false,
      form: {
        Title: null,
        Uri: null,
        Type: 0,
        Description: '',
        SendTime: null,
        SegmentIds: null,
        userIds: [],
        IsDraft: true,
        CouponId: null,
        SaveInInbox: true
      },
      calculateInfo: {},
      CalculateLoading: true,
      calculate: {
        loading: false,
        isDone: false,
        details: {},
      },
    }
  },
  created() {
    if (this.$route.params.messageId && this.$route.params.messageId !== ('new')) {
      this.showMessageDetail(this.$route.params.messageId)
    }
    if (this.$route.params.customSegmentId) {
      // connect server to get detail message
      this.form.SegmentIds = parseInt(this.$route.params.customSegmentId, 10)
    }
  },
  methods: {
    calculatePrice() {
      this.calculate.loading = true
      this.$http.post(this.$api.declarations.price, {
        Ids: this.form.SegmentIds,
        Description: this.form.Description,
      }).then(response => {
        this.calculate.details = response.data
        this.calculate.loading = false
        this.calculate.isDone = true
      }).finally(() => { this.calculate.loading = false })
    },
    save() {
      this.form.Id = this.$route.params.messageId || null
      this.loading = true

      let url = this.$api.declarations.add
      if (this.form.Id){
        url = this.$api.declarations.update
      }

      this.$http.post(url, this.form).then(() => {
        this.loading = false
        this.back()
      }).finally(() => {
        this.loading = false
      })
    },
    showMessageDetail(declarationId) {
      this.loading = true
      this.$http.post(this.$api.declarations.get, { id: declarationId }).then(response => {
        this.form = response.data
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    update() {
      this.loading = true
      this.$http.post(this.$api.declarations.update, this.form).then(() => {
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>

</style>
